import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import idlingConsumptionBasicInformationPropTypes from '../proptypes/IdlingConsumptionBasicInformationPropTypes';

const IdlingConsumptionBasicInformationResource = ({
  id,
  itineraryId,
  idlingConsumptionMotive,
  idlingConsumptionTime,
  idlingConsumptionNumberOfGallon,
  observation,
  realIdlingConsumptionNumberOfGallon,
  realIdlingConsumptionTime,
}) => (
  <>
    <ResourceProperty label="ID:">{id || '-'}</ResourceProperty>
    <ResourceProperty label="Itinerario:">
      {itineraryId || '-'}
    </ResourceProperty>
    <ResourceProperty label="Motivo:">
      {idlingConsumptionMotive.description || '-'}
    </ResourceProperty>
    <ResourceProperty label="Tiempo Parado (Minutos):">
      {idlingConsumptionTime || '-'}
    </ResourceProperty>
    <ResourceProperty label="Galones Consumidos:">
      {idlingConsumptionNumberOfGallon || '-'}
    </ResourceProperty>
    <ResourceProperty label="Tiempo Parado Real (Minutos):">
      {realIdlingConsumptionTime || '-'}
    </ResourceProperty>
    <ResourceProperty label="Galones Consumidos (Real):">
      {realIdlingConsumptionNumberOfGallon || '-'}
    </ResourceProperty>
    <h5>Observaciones</h5>
    <p>{observation}</p>
  </>
);

IdlingConsumptionBasicInformationResource.propTypes =
  idlingConsumptionBasicInformationPropTypes;

export default IdlingConsumptionBasicInformationResource;
